.dropdownMenu {
  .activator {
    --ixf-button-justify-content: flex-start;
    --ixf-button-text-align: left;

    .buttonContentContainer {
      width: 100%;
      overflow: hidden;

      .disclosureIcon {
        transform: rotate(90deg);
      }

      .content {
        width: 100%;
        flex: 1 1 auto;
        white-space: nowrap;
        overflow: hidden;
        display: block;
        text-overflow: ellipsis;
      }
    }
  }
}

.popover {
  background: var(--ixf-color-background);
  overscroll-behavior-y: contain;

  &[data-state="closed"] {
    display: none;
  }

  .menu {
    .group {
      .heading {
        letter-spacing: 1px;
        padding: var(--ixf-space-3);
      }

      &:not(:last-child) {
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          background-color: var(--ixf-color-separator);
          margin: var(--ixf-space-2) 0;
        }
      }
    }
  }
}
